/**
 * Canonical inventory of exact paths rendered by App.tsx.
 * Redirect-only legacy paths and dynamic blog/accessory paths do not belong here.
 */
export const APP_STATIC_ROUTE_DEFINITIONS = [
  { path: '/' },
  { path: '/admin', noindex: true },
  { path: '/medical-alerts' },
  { path: '/how-it-works' },
  { path: '/pricing' },
  { path: '/products/ez-care' },
  { path: '/products/ez-care-plus' },
  { path: '/products/lifebeacon' },
  { path: '/products/medical-alert-bracelets/796' },
  { path: '/our-story' },
  { path: '/help' },
  { path: '/my-account', noindex: true },
  { path: '/cart', noindex: true },
  { path: '/checkout', noindex: true },
  { path: '/order-success', noindex: true },
  { path: '/healthcare-providers' },
  { path: '/current-members' },
  { path: '/refer-friend' },
  { path: '/accessories' },
  { path: '/where-it-works' },
  { path: '/reviews' },
  { path: '/blog' },
  { path: '/blog/fall-prevention' },
  { path: '/blog/home-safety' },
  { path: '/blog/caregiver-payment' },
  { path: '/privacy' },
  { path: '/terms' },
  { path: '/compare' },
  { path: '/why-alert1/first-alert-medical-system' },
  { path: '/resources/medicare-medicaid-medical-alert' },
  { path: '/resources/senior-cell-phone-reviews-medical-alerts/7125' },
  { path: '/resources/medical-alert-system-glossary/209' },
  { path: '/resources/baby-boomer-facts-and-statistics/426' },
  { path: '/pricing/compare-medical-alert-systems' },
  { path: '/pricing/compare-alert1-to-life-alert' },
  { path: '/pricing/compare-alert1-to-bay-alarm' },
  { path: '/pricing/compare-alert1-to-medical-guardian' },
  { path: '/pricing/compare-alert1-to-greatcall' },
  { path: '/pricing/compare-alert1-to-mobilehelp' },
  { path: '/pricing/compare-alert1-to-adt-health' },
  { path: '/content/personal-emergency-response-system/789' },
  { path: '/life-alert-compared-to-alert1' },
  { path: '/why-alert1/life-alert-alternatives/791' },
  { path: '/faq' },
  { path: '/contact' },
  { path: '/request-brochure' },
  { path: '/request-admin-access', noindex: true },
  { path: '/decrypt-orders-report', noindex: true },
  { path: '/forgot-password', noindex: true },
  { path: '/sign-up', noindex: true },
  { path: '/troubleshooting' },
  { path: '/blog-admin', noindex: true },
  { path: '/campaigns', noindex: true },
  { path: '/template-designer', noindex: true },
  { path: '/contacts', noindex: true },
  { path: '/messaging', noindex: true },
  { path: '/shipments', noindex: true },
  { path: '/excel-tools', noindex: true },
  { path: '/record-matching', noindex: true },
  { path: '/railway-health-check', noindex: true },
  { path: '/agingparents', noindex: true },
];

export const APP_STATIC_ROUTES = APP_STATIC_ROUTE_DEFINITIONS.map(({ path }) => path);
export const APP_STATIC_ROUTE_SET = new Set(APP_STATIC_ROUTES);

export const NOINDEX_PATHS = APP_STATIC_ROUTE_DEFINITIONS
  .filter((route) => route.noindex)
  .map(({ path }) => path);
export const NOINDEX_ROUTE_SET = new Set(NOINDEX_PATHS);

export const PRODUCT_ROUTE_SET = new Set(
  APP_STATIC_ROUTES.filter((path) => path.startsWith('/products/'))
);

export const BLOG_CATEGORY_ROUTE_SET = new Set(
  APP_STATIC_ROUTES.filter((path) => path === '/blog' || path.startsWith('/blog/'))
);
